<template>
  <div class="fileinput"
    @dragenter="enteringDrag"
    @dragleave="leavingDrag"
    @dragover.prevent="enteringDrag"
    @drop.prevent="handleDrop" ref="fileInput">
    <input type="file" class="inv_input" id="fileInput" @input="manageFile"
      :accept="approvedFormats" ref="inputFile">
    <div class="fileinput_body" :style="currentStyles" v-if="!fileReceived"
      @click="openInput"></div>
    <div class="fileinput_preview" :style="currentStyles" v-else>
      <img :src="imagePreview" v-if="filetype === 'image'" class="base_image"
        @click="clearPreview"/>
      <div :class="`${filetype}_preview`" v-else></div>
     </div>
    <label for="fileInput" class="fileinput_label">{{ text }}</label>
  </div>
</template>
<script>
import { reactive } from 'vue';

export default {
  name: 'fileInput',
  props: {
    text: {
      type: String,
      required: true,
    },
    filetype: {
      type: String,
      required: false,
      default: 'image',
    },
    size: {
      type: Number,
      required: false,
      default: 70,
    },
  },
  data() {
    return {
      currentStyles: reactive({
        width: `${this.size}px`,
        height: `${this.size}px`,
      }),
      allFormats: {
        image: 'image/*',
        video: 'video/*',
        audio: 'audio/*',
      },
      fileReceived: false,
      currentFiletype: this.filetype,
      imagePreview: null,
    };
  },
  computed: {
    approvedFormats() {
      return this.allFormats[this.filetype];
    },
  },
  methods: {
    enteringDrag() {
      this.$refs.fileInput.classList.add('active');
    },
    leavingDrag() {
      this.$refs.fileInput.classList.remove('active');
    },
    handleDrop() {
      const file = event.dataTransfer.files[0];
      const type = file ? file.type : null;
      this.currentFiletype = type;
      if (['image/jpg', 'image/jpeg', 'image/png'].includes(type)) {
        this.makePreview(file);
      }
      this.leavingDrag();
      this.fileReceived = true;
      this.$emit('input', this.imageFile);
    },
    makePreview(file) {
      this.imagePreview = URL.createObjectURL(file);
      this.imageFile = file;
    },
    manageFile() {
      const file = event.target.files[0];
      const type = file ? file.type : null;
      this.currentFiletype = type;
      if (['image/jpg', 'image/jpeg', 'image/png'].includes(type)) {
        this.makePreview(file);
      }
      this.fileReceived = true;
      this.$emit('input', this.imageFile);
    },
    clearPreview() {
      this.imageFile = null;
      this.imagePreview = null;
      this.fileReceived = false;
      this.$emit('input', null);
    },
    openInput() {
      this.$refs.inputFile.click();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";

.fileinput{
  display: flex;
  align-items: center;
  &.active &_body{
    box-shadow: inset 0px 0px 10px 1px rgba($color: #333, $alpha: .6);
    animation: pulsate 1.5s ease-in-out infinite;
  }
  &_body{
    border-radius: 8px;
    box-shadow: $main-shadow;
    position: relative;
    cursor: pointer;
    &:after{
      width: 100%;
      height: 100%;
      position: absolute;
      content: '\f0c6';
      font-family: 'FontAwesome';
      font-size: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba($color: white, $alpha: .6);
    }
  }
  &_preview{
    border-radius: 8px;
    cursor: pointer;
  }
  &_label{
    margin-left: 10px;
    color: white;
    font-family: $font;
    font-size: 17px;
    cursor: pointer;
  }
}
@keyframes pulsate {
  0% {box-shadow: inset 0px 0px 3px 1px rgba($color: #333, $alpha: .5);}
  50% {box-shadow: inset 0px 0px 15px 1px rgba($color: #333, $alpha: .8);}
  100% {box-shadow: inset 0px 0px 3px 1px rgba($color: #333, $alpha: .5);}
}
</style>



// WEBPACK FOOTER //
// src/components/fileInput.vue